<template>
    <div class="small-label-component" :style="{height: domHieght/3.75 + 'vw', lineHeight: domHieght/3.75 + 'vw', color:txtColor, background:bgColor, border: borderColor ? '0.3vw solid' +  borderColor : 'none'}">
        <slot />
    </div>
</template>
<script>
    export default {
        components: {},
        props: {
            // 文字颜色
            txtColor: {
                type: String,
                default: ''
            },
            // 背景颜色
            bgColor: {
                type: String,
                default: ''
            },
            // 边框颜色
            borderColor: {
                type: String,
                default: ''
            },
            domHieght: {
                type: Number,
                default: 18
            }
        },
        data () {
            return {
            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  @vv: 3.75vw;
  .small-label-component{
    display: flex;
    margin-right: 3/@vv;
    height: 18/@vv;
    box-sizing: border-box;
    padding:0/@vv 4/@vv;
    font-size:10/@vv;
    line-height: 20/@vv;
    font-family:PingFangSC-Regular,PingFang SC;
    -webkit-font-smoothing: antialiased;
    font-weight:400;
    border-radius:1/@vv;
    text-align: center;
  }

</style>
